/**
 * Handle request errors
 * @param {Object} res - fetch() response
 * @returns {Object} res - response data
 */
const _handleErrors = async(res) => {
    if (!res.ok) {
        // TODO: need to handle here if the API returns any errors in non-json format
        throw await res.json();
    }
    return res;
};

/**
* Makes ajax call
* @param {string} url - endpoint url
* @param {string} env - application's env value
* @param {Object} options - method, content-type,etc
* @returns {Promise}
**/

module.exports = {
    request: function request(basepath, endpoint, options) {
        const DEFAULTS = {
            method: 'GET',
            contentType: 'application/json',
            headers: {
                credentials: 'same-origin'
            }
        };

        if (!basepath || !endpoint) {
            throw new Error('API url is not valid.');
        }

        // set timeout
        const { timeout = 5000 } = options || {};
        const controller = new AbortController();
        const id = setTimeout(() => controller.abort(), timeout);

        const path = `${basepath}${endpoint}`;
        return new Promise((resolve, reject) => {
            fetch(path, Object.assign({}, DEFAULTS, options, { signal: controller.signal }))
                .then(_handleErrors)
                .then(res => res.json())
                .then(resolve)
                .catch(reject)
                .finally(() => {
                    clearTimeout(id);
                });
        });
    }
};
